import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
//import Login from "../components/Login.vue"
//import Secure from "../views/Secure.vue"
//import Bord from "../views/Bord.vue"


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Hjem',
    component: Home
  },
  {
    path: '/bord',
    name: 'Bord',
    component: () => import(/* webpackChunkName: "bord" */ '../views/Bord.vue')
  },  
  {
    path: '/admin',
    redirect: 'Login'
  },
  {
    path: '/secure',
    name: 'secure',
    //    component: Secure, 
    component: () => import(/* webpackChunkName: "secure" */ '../views/Secure.vue'),
    beforeEnter: (to, from, next) => {
      if(store.state.authenticated == false) {
        console.log("false")
          next(false);
      } else {
        console.log("true")
          next();
      }
    }    
  },  
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ '../components/Login.vue')
  },

]                               

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
